/* eslint-disable */
import { includes } from "rambdax"
import emojiRegexFn from "emoji-regex"
import { isPossiblePhoneNumber } from "libphonenumber-js"
import * as dayjs from 'dayjs'
import { isEmpty } from "ramda"
const ValidateJS = require("validate.js")

const emojiRegex = emojiRegexFn()

// HACK(steve): wierd typescript situation because of strange typings
const Validate: any = ValidateJS.default ? ValidateJS.default : ValidateJS

/**
 * Validates that 1 attribute doesn't appear in another's attributes content.
 */
Validate.validators.excludes = function custom(
  value: any,
  options: any,
  _: any,
  attributes: any,
) {
  const list = attributes[options.attribute] || []
  if (value && includes(value, list)) {
    return options.message || `${value} is in the list`
  }
}

Validate.extend(Validate.validators.datetime, {
  parse: (value: any, _: any) => {
    return +dayjs.utc(value)
  },
  format: (value: any, options: any) => {
    var format = options.dateOnly ? "YYYY-MM-DD" : "YYYY-MM-DD hh:mm:ss"
    return dayjs.utc(value).format(format)
  },
})

/**
 * Validates that another attribute isn't true.
 */
Validate.validators.tripped = function custom(
  value: any,
  options: any,
  _: any,
  attributes: any,
) {
  if (value && attributes[options.attribute] === true) {
    return options.message || `${options.attribute} is true`
  }
}

/**
 * Validates emoji
 */
Validate.validators.noEmoji = function custom(value: any, options: any) {
  if (value && !!value.match(emojiRegex)) {
    return options.message || "validations.noEmoji"
  }
}

/**
 * Validates phone number
 */
Validate.validators.possiblePhoneNumber = function (
  value: string,
  options: any,
) {
  if (!isPossiblePhoneNumber(value))
    return options.message || "validations.possiblePhoneNumber"
}
ValidateJS.validators.array = (
  arrayItems: Array<any>,
  itemConstraints: any,
) => {
  const arrayItemErrors = arrayItems.reduce((errors, item, index) => {
    const error = ValidateJS.validate(item, itemConstraints)
    if (error) errors[index] = { error: error }
    return errors
  }, {})

  return isEmpty(arrayItemErrors) ? null : { errors: arrayItemErrors }
}

/**
 * Defines the rules for validating.
 *
 * Example:
 * ```ts
 * const RULES = {
 *   favoriteBand: {
 *     inclusion: { ['Weezer', 'Other'], message: 'Pick wisely.' }
 *   },
 *   name: {
 *     presence: { message: 'A developer has no name?' }
 *   }
 * }
 * validate(RULES, {})
 * ```
 *
 * See https://validatejs.org/#validators for more examples.
 *
 */
export interface ValidationRules {
  [key: string]: {}
}

/**
 * An object containing any errors found.
 *
 * Example:
 * ```js
 * {
 *   email: ['Invalid email address.'],
 *   password: [
 *     'Password must be 6 characters.',
 *     'Password must have at least 1 digit.'
 *   ]
 * }
 * ```
 */
export interface ValidationErrors {
  [key: string]: string[]
}

/**
 * Runs the given rules against the data object.
 *
 * @param rules The rules to apply.
 * @param data The object to validate.
 */
export function validate(rules: ValidationRules, data: {}): ValidationErrors {
  if (typeof data !== "object") {
    return {}
  }
  return Validate(data, rules, { fullMessages: false }) || {}
}

export function validateEmail(email: string) {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}
